import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CartInErrorDialog } from '@component/Dialog';
import { addCartDialogAction } from '@app/react/action';
import type { AsyncGeneralState } from '@app/react/const/type';
import type { AppState } from '@app/react/reducer';

const selectCartInState = (state: AppState): AsyncGeneralState => state.uiCustomDesign.cartInState;

const selectCustomize = (state: AppState): DesignSet => state.customize;

export const CartInErrorDialogContainer: FC = () => {
    const dispatch = useDispatch();
    const state = useSelector(selectCartInState);
    const customizeData = useSelector(selectCustomize);

    const closeErrorDialog = () => {
        dispatch(addCartDialogAction({ show: false }));
    };

    return (
        <CartInErrorDialog
            isShow={state === 'error'}
            closeErrorDialog={closeErrorDialog}
            customizeData={customizeData}
        />
    );
};
